import { AxiosResponse } from 'axios'
import { apiNode } from './api'
import { sanitizeNoteHtml } from '../utils/sanitizeNoteHtml'
import {
	CreateNoteData,
	DefaultNotesParamsProps,
	GetNotesDataResponse,
	GetNoteSharedUsersDataResponse,
	GetNotesParamsProps,
	GetTagsDataResponse,
	PinNoteDataProps,
	SetSharedUsersDataProps,
} from './types/notes.interfaces'

const URL = '2/notes'

export const NotesService = {
	async get({
		...params
	}: GetNotesParamsProps): Promise<GetNotesDataResponse> {
		const response: AxiosResponse<GetNotesDataResponse> =
			await apiNode.get<GetNotesDataResponse>(`${URL}`, {
				params,
			})
		return response.data
	},

	async create({ data }: { data: CreateNoteData }) {
		return await apiNode.post(`${URL}/create`, { ...data, body: sanitizeNoteHtml(data.body) })
	},

	async getTags(): Promise<GetTagsDataResponse> {
		const response: AxiosResponse<GetTagsDataResponse> =
			await apiNode.get<GetTagsDataResponse>(`${URL}/tags`)
		return response.data
	},

	async update({
		data,
		id,
	}: {
		data: CreateNoteData
		id: string
	}) {
		return await apiNode.patch(`${URL}/${id}/update`, { ...data, body: sanitizeNoteHtml(data.body) })
	},

	async delete({ id }: DefaultNotesParamsProps) {
		return await apiNode.delete(`${URL}/${id}/delete`)
	},

	async pin({ id, value }: PinNoteDataProps) {
		return await apiNode.post(`${URL}/${id}/pin`, { value })
	},

	async getNoteSharedUsers({
		id,
	}: DefaultNotesParamsProps): Promise<GetNoteSharedUsersDataResponse> {
		const response: AxiosResponse<GetNoteSharedUsersDataResponse> =
			await apiNode.get<GetNoteSharedUsersDataResponse>(
				`${URL}/${id}/permissions`,
			)
		return response.data
	},

	async setNoteSharedUsers({ data, id }: SetSharedUsersDataProps) {
		return await apiNode.put(`${URL}/${id}/permissions`, data)
	},
}
